import { changeSignInState } from '../../actions/presenceActions';
import signOut from '../services/signOut';
import ChatSignInState from '../../store/schema/ChatSignInState';
import { logUsage } from 'owa-analytics';

export default function signOutIM() {
    changeSignInState(ChatSignInState.AttemptingSignOut);
    signOut()
        .then(() => {
            changeSignInState(ChatSignInState.SignedOut);
        })
        .catch(() => {
            changeSignInState(ChatSignInState.SignedOut);
        });
    logUsage('UcmaSkypeSignOut');
}
